import $ from "jquery";
import { smoothscroll } from "../utils/smoothscroll";
import { debounce } from "../utils/functions";

const $body = $(".page__body");

const initialScroll = () => {
  const url = new URL(window.location);
  let scrollTo = url.searchParams.get("psn");
  const awaitHeader = url.searchParams.get("await_header");

  if (scrollTo) {
    const scrollToInt = parseInt(scrollTo);
    scrollTo = isNaN(scrollToInt) ? scrollTo : scrollToInt;

    const minDuration = 500;
    let duration = isNaN(scrollToInt)
      ? minDuration
      : (scrollTo * minDuration) / 3000;
    duration = duration > minDuration ? duration : minDuration;

    if (awaitHeader) {
      url.searchParams.delete("await_header");
      window.history.replaceState({}, "", url);
      smoothscroll(scrollTo, "header", duration);
    } else {
      smoothscroll(scrollTo, 0, duration);
    }
  }
};

const setPsn = (init = false) => {
  const url = new URL(window.location);
  let canSet = true;

  if (init === true) {
    if (url.searchParams.get("psn")) {
      canSet = false;
    }
  }

  if (canSet === true) {
    if ($body.scrollTop() != 0) {
      url.searchParams.set("psn", $body.scrollTop());
      window.history.replaceState({}, "", url);
    } else {
      url.searchParams.delete("psn");
      window.history.replaceState({}, "", url);
    }
  }
};

setPsn(true);
$body.on("scroll", debounce(setPsn));
initialScroll();
